export const parseDefectsString = (s = "") => {
  if (!s || typeof s !== "string") return [];
  const trimmed = s.replace(/^[^:]*:\s*/, "").trim();
  if (!trimmed) return [];

  // Try numbered: "1. aaa, 2. bbb, 3. ccc"
  const re = /(?:^|\s)(\d+)\.\s([^]+?)(?=(?:\s*\d+\.\s)|$)/g;
  const items = [];
  let m;
  while ((m = re.exec(trimmed)) !== null) {
    const t = (m[2] || "").replace(/[,\s]+$/g, "").trim();
    if (t) items.push(t);
  }
  if (items.length) return items;

  // Fallback: split on commas/semicolons
  return trimmed.split(/[;,]\s*/g).map(x => x.trim()).filter(Boolean);
};

// number and join: ["a","b"] -> "1. a, 2. b"
export const toNumberedString = (arr = []) =>
  arr.map((t, i) => `${i + 1}. ${t}`).join(", ");